import styled from 'styled-components';


export const EmptyMessage = styled.p`
    font-size: 1rem;
    font-weight: bold;
    text-align: center;
`;